// Root reducer combining all feature reducers

import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from '@/services/api/baseApi';

export const rootReducer = combineReducers({
  // API slice reducer
  [baseApi.reducerPath]: baseApi.reducer,
  
  // Feature reducers will be added here as they are created
  // auth: authSlice.reducer,
  // services: servicesSlice.reducer,
  // analytics: analyticsSlice.reducer,
  // payouts: payoutsSlice.reducer,
});
